import React from "react";
import "./Devices.css";
import ConnectedDevices from "./ConnectedDevices.js";

const Devices = ({
  devices_list,
  device_connector_mapping,
  selectedConnector,
  connectorsList,
  updateConnectorsListWithDevices,
  adapters_list,
}) => {
  const getDevicesForConnector = (connector) => {
    const connector_mapping = device_connector_mapping.find(
      (mapping) => mapping.connector_id === connector.id
    );
    return connector_mapping.devices.map((device) =>
      devices_list.find(
        (item_device_find) => item_device_find.id === device.device_id
      )
    );
  };

  const getConnectedDevicesForConnector = (connector) => {
    const devices_id = connectorsList.filter(
      (connector_item) => connector_item.id === connector.id
    )[0].connected_devices_id;
    return devices_id.map((device_id) =>
      devices_list.find((device) => device.id === device_id)
    );
  };

  const getDeviceConnectionDetail = (device, connector) => {
    const found_device_connector_mapping = device_connector_mapping.find(
      (item) => item.connector_id === connector.id
    );
    const device_connection_detail =
      found_device_connector_mapping.devices.find(
        (item) => item.device_id === device.id
      );
    return device_connection_detail;
  };

  return (
    <>
      {/* <h3>Devices</h3> */}
      {selectedConnector ? (
        <div className="device-connected-list fade-in">
          {getConnectedDevicesForConnector(selectedConnector).length > 0 ? (
            <div className="device-found fade-in">
              {getConnectedDevicesForConnector(selectedConnector).map(
                (device) => (
                  <div className="">
                    <ConnectedDevices
                      device={device}
                      connectionDetail={getDeviceConnectionDetail(
                        device,
                        selectedConnector
                      )}
                      selectedConnector={selectedConnector}
                      updateConnectorsListWithDevices={
                        updateConnectorsListWithDevices
                      }
                      adapters_list={adapters_list}
                    />
                  </div>
                )
              )}
            </div>
          ) : (
            <div className="device-not-found text-center text-warning fs-4 align-middle">
              No device connected
              <br />
              Please select one from the list below
            </div>
          )}
        </div>
      ) : (
        <div className="no-connector-selected text-center  text-warning fs-3">
          select a connector first
        </div>
      )}
    </>
  );
};

export default Devices;
